import * as queryString from 'query-string';

const parameters = queryString.parse(window.location.search);

const API = parameters.api_url || process.env.REACT_APP_API_URL || 'https://api.qa.corva.ai';
const DATA_API = process.env.REACT_APP_DATA_API_URL || API.replace('api', 'data');
const FUSION_API = process.env.REACT_APP_FUSION_API_URL || API.replace('api', 'fusion');
const STREAMX_API = process.env.REACT_APP_STREAMX_API_URL || API.replace('api', 'streamx-api');

export const CORVA_API_URLS = {
  API,
  DATA_API,
  FUSION_API,
  STREAMX_API,
};
